import { render } from "./VersionsHistory.vue?vue&type=template&id=fa153f6c&scoped=true"
import script from "./VersionsHistory.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./VersionsHistory.vue?vue&type=script&charset=utf-8&lang=js"

import "./VersionsHistory.vue?vue&type=style&index=0&id=fa153f6c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa153f6c"]])

export default __exports__